module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/137.2500a4a7.png";